export default __webpack_public_path__ + "static/media/carousel-1.8b6d1038.webp";